module.exports = __webpack_public_path__ + "static/media/ill_insektsbett.717e8745.svg";